"use client";

import { ReactNode, useEffect, useState } from "react";
import SiteFooter from "@/components/SiteFooter";
import SiteHeader from "@/components/SiteHeader";
import MemberLayout from "@/components/MemberLayout";
import { readSession } from "@/lib/session";
import { usePullToReload } from "@/lib/usePullToReload";

function isMemberSession() {
  const session = readSession();
  return session?.role === "member" || session?.role === "committee";
}

export default function SiteChrome({ children }: { children: ReactNode }) {
  // Keep SSR + first client paint identical (always guest chrome), then switch after mount.
  // useSyncExternalStore(cookie) caused hydration mismatches for logged-in members.
  const [member, setMember] = useState(false);
  usePullToReload(".site-shell-body");

  useEffect(() => {
    setMember(isMemberSession());
  }, []);

  if (member) return <MemberLayout>{children}</MemberLayout>;
  return (
    <div className="site-shell">
      <SiteHeader userRole="guest" />
      <div className="site-shell-body">
        {children}
        <SiteFooter />
      </div>
    </div>
  );
}
